import {
  AccordionSummary,
  Grid,
  Input,
  NativeSelect,
  TextareaAutosize,
  Typography,
} from '@material-ui/core';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Paper from '@material-ui/core/Paper';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import ReactInputMask from 'react-input-mask';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Loading from '../../../../components/Loading';
import Header from '../../../../layout/Header';
import Subheader from '../../../../layout/Subheader';
import api from '../../../../services/api';
import { TOKEN_USER } from '../../../../services/auth';
import { handleErrorRequest } from '../../../../utils/errorsValidation';
import { formatDateTimeToRender } from '../../../../utils/functions';
import useStyles from '../style';

export function AnotationProviderRegister() {
  const classes = useStyles();
  const { id, idAnotacao } = useParams();
  const loginId = JSON.parse(sessionStorage.getItem(TOKEN_USER)).loginId;

  const [isLoading, setLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const [isRegister, setIsRegister] = useState(false);

  const [formValues, setFormValues] = useState({
    dataAgendamento: null,
    ancoraId: 0,
    fornecedorId: 0,
    loginId: 0,
  });
  const [getErros, setErros] = useState([]);
  const [anchors, setAnchors] = useState();
  const [provider, setProvider] = useState([]);

  const handleInputChange = (event, value) => {
    event.persist();
    setFormValues((inputs) => ({ ...inputs, [event.target.name]: value || event.target.value }));
  };

  const updateAnchor = async (payload) => {
    const payloadUpadte = {
      ...payload,
      fornecedorAnotacaoId: Number(idAnotacao),
      dataAtualizacao: formValues.dataAtualizacao,
    };
    try {
      const response = await api.put('FornecedoresAnotacoes', payloadUpadte);
      if (response.data.status !== 'Inconsistencia') {
        toast.success('Anotação alterada com sucesso!');
        setFormValues({
          ...response.data.resposta,
          ...(formValues.dataAgendamento && {
            dataAgendamento: formatDateTimeToRender(response.data.resposta.dataAgendamento),
          }),
        });
      } else {
        setErros(handleErrorRequest(response));
      }
    } catch (error) {
      setErros(handleErrorRequest(error.response));
    }
  };

  const createAnchor = async (payload) => {
    try {
      const response = await api.post('FornecedoresAnotacoes', payload);
      if (response.data.status !== 'Inconsistencia') {
        toast.success('Anotação criada com sucesso!');
        setFormValues({
          ancoraId: 0,
          dataAgendamento: null,
          fornecedorId: 0,
          loginId: 0,
          ocorrencia: '',
        });
      } else {
        setErros(handleErrorRequest(response));
      }
    } catch (error) {
      setErros(handleErrorRequest(error.response));
    }
  };

  const onSubmit = async () => {
    const payload = {
      ...formValues,
      ...(formValues.ancoraId && { ancoraId: Number(formValues.ancoraId) }),
      ...(formValues.dataAgendamento
        ? {
            dataAgendamento: moment(formValues.dataAgendamento, 'DD/MM/YYYY').toDate(),
          }
        : { dataAgendamento: null }),
      ...(loginId && { loginId: Number(loginId) }),
      ...(id && { fornecedorId: Number(id) }),
    };
    isRegister ? createAnchor(payload) : updateAnchor(payload);
  };

  const fetchProviderById = async (id) => {
    if (!id) return;
    setLoading(true);
    try {
      const res = await api.get(`FornecedoresAnotacoes/ConsultarId?id=${id}`);
      setFormValues(res.data.resposta);
      if (res.data.resposta.dataAgendamento) {
        setFormValues((prev) => ({
          ...prev,
          dataAgendamento: formatDateTimeToRender(res.data.resposta?.dataAgendamento),
        }));
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  const fetchAnchors = async () => {
    const res = await api.get('Ancoras/Consultar?status=Ativo');
    setAnchors(res.data.resposta);
  };

  const fetchProvider = async () => {
    const res = await api.get(`Fornecedores/ConsultarId?id=${id}`);
    setProvider(res.data.resposta);
  };

  useEffect(() => {
    fetchAnchors();
    fetchProvider();
    if (window.location.pathname.includes('cadastrar')) {
      setIsEditing(true);
      setIsRegister(true);
      setLoading(false);
      return;
    }
    if (window.location.pathname.includes('editar')) {
      fetchProviderById(idAnotacao);
      setIsEditing(true);
      return;
    }
    setIsEditing(false);
    setIsRegister(false);
    fetchProviderById(idAnotacao);
  }, [idAnotacao]);

  return (
    <div className={classes.root}>
      <Header />
      {isEditing ? (
        <Subheader
          title={`${isRegister ? 'Cadastrando' : 'Atualizando'} anotação do fornecedor - ${
            (!isRegister && provider?.nomeFantasia) || ''
          }`}
          loading={isLoading}
          submit={onSubmit}
          back={false}
          submitText={`${isRegister ? 'Cadastrar' : 'Atualizar'}`}
        />
      ) : (
        <Subheader
          loading={isLoading}
          back={false}
          title={`Visualizando anotação do fornecedor - ${
            (!isRegister && provider?.nomeFantasia) || ''
          }`}
        />
      )}
      <div className={classes.content}>
        <div className={classes.rootForm}>
          {isLoading ? (
            <Loading />
          ) : (
            <div>
              <form onSubmit={onSubmit}>
                <Accordion defaultExpanded>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.summary}>
                    <Typography className={classes.heading}>Informações</Typography>
                  </AccordionSummary>
                  <AccordionDetails className={classes.details}>
                    <Grid container>
                      <Grid item xs={6}>
                        <label className={classes.label}>Rede</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            onChange={handleInputChange}
                            className={classes.input}
                            value={formValues?.ancoraId}
                            name="ancoraId"
                            disabled={!isEditing && !isRegister}
                            error={getErros.includes('AncoraId')}
                            onBlur={(event) =>
                              getErros.includes('AncoraId') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'AncoraId';
                                }),
                              )
                            }
                          >
                            <option value="0">FALTA PREENCHER</option>
                            {anchors?.map((anchor) => (
                              <option key={anchor.ancoraId} value={anchor.ancoraId}>
                                {anchor.nomeFantasia}
                              </option>
                            ))}
                          </NativeSelect>
                        </Paper>
                      </Grid>

                      <Grid item xs={6} className={classes.item}>
                        <label className={classes.label}>Data agendamento</label>
                        <Paper className={classes.medium} elevation={0}>
                          <ReactInputMask
                            mask="99/99/9999"
                            style={{ textTransform: 'uppercase !important' }}
                            className={classes.input}
                            value={formValues?.dataAgendamento}
                            classes={{ input: classes.inputText }}
                            placeholder="__/__/____"
                            onChange={handleInputChange}
                            error={getErros.includes('DataAgendamento')}
                            onBlur={(event) =>
                              getErros.includes('DataAgendamento') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'DataAgendamento';
                                }),
                              )
                            }
                            disabled={!isEditing}
                            name="dataAgendamento"
                          >
                            {() => (
                              <Input
                                disabled={!isEditing}
                                className={classes.input}
                                placeholder="__/__/____"
                                name="dataAgendamento"
                                error={getErros.includes('DataAgendamento')}
                              />
                            )}
                          </ReactInputMask>
                        </Paper>
                      </Grid>

                      <Grid item xs={12}>
                        <label className={classes.label}>Ocorrência</label>
                        <Paper className={classes.medium} elevation={0} style={{ width: '100%' }}>
                          <TextareaAutosize
                            onChange={handleInputChange}
                            minRows={3}
                            style={{ textTransform: 'uppercase !important' }}
                            className={classes.input}
                            classes={{ input: classes.inputText }}
                            error={getErros.includes('Ocorrencia')}
                            onBlur={(event) =>
                              getErros.includes('Ocorrencia') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'Ocorrencia';
                                }),
                              )
                            }
                            value={formValues?.ocorrencia || ''}
                            disabled={!isEditing}
                            name="ocorrencia"
                          />
                        </Paper>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>

                {!isRegister && (
                  <Accordion defaultExpanded>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                      className={classes.summary}
                    >
                      <Typography className={classes.heading}>Dados do Registro</Typography>
                    </AccordionSummary>
                    <AccordionDetails className={classes.details}>
                      <Grid container>
                        <Grid item xs={6}>
                          <label className={classes.label}>Data de Registro</label>
                          <Paper className={classes.medium} elevation={0}>
                            <Input
                              className={classes.input}
                              value={
                                formValues.dataRegistro &&
                                formatDateTimeToRender(formValues.dataRegistro)
                              }
                              readOnly
                              disabled={!isEditing}
                              placeholder="Data do Registro"
                            />
                          </Paper>
                        </Grid>

                        <Grid item xs={6}>
                          <label className={classes.label}>Data da Atualização</label>
                          <Paper className={classes.medium} elevation={0}>
                            <Input
                              className={classes.input}
                              value={
                                formValues.dataAtualizacao
                                  ? formatDateTimeToRender(formValues.dataAtualizacao)
                                  : ''
                              }
                              readOnly
                              disabled={!isEditing}
                              placeholder="Data da Atualização"
                            />
                          </Paper>
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                )}
                {(isRegister || isEditing) && (
                  <div className={classes.divButton}>
                    <button
                      variant="contained"
                      type="button"
                      onClick={onSubmit}
                      className={classes.button}
                    >
                      {isRegister ? 'Cadastrar' : 'Atualizar'}
                    </button>
                  </div>
                )}
              </form>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
